<template>
  <div class="edit-maintenance">
    <Form :model="record" :label-width="120">
      <FormItem label="维修单号：">
        <Input v-model="record.id" disabled />
      </FormItem>

      <FormItem label="设备信息：">
        <div>{{ device.alias }} (SN: {{ device.sn }})</div>
      </FormItem>

      <FormItem label="开始时间：">
        <DatePicker
            type="datetime"
            v-model="startTimeValue"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择开始时间"
            style="width: 200px"
        />
      </FormItem>

      <FormItem label="结束时间：">
        <DatePicker
            type="datetime"
            v-model="endTimeValue"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择结束时间"
            style="width: 200px"
            :disabled="record.maintenanceStatus === '0'"
        />
      </FormItem>

      <FormItem label="维修状态：">
        <RadioGroup v-model="myMaintenanceStatus" >
          <Radio label="维修中" value="0">维修中</Radio>
          <Radio label="维修完毕" value="1">维修完毕</Radio>
        </RadioGroup>
      </FormItem>

<!--      <FormItem label="维修技师：">-->
<!--        <Input v-model="record.technician" placeholder="输入维修技师姓名" />-->
<!--      </FormItem>-->

      <FormItem label="维修描述：">
        <Input
            v-model="record.description"
            type="textarea"
            :autosize="{minRows: 4, maxRows: 8}"
            placeholder="详细描述维修内容..."
        />
      </FormItem>

<!--      <FormItem label="附件：">-->
<!--        <Upload action="//jsonplaceholder.typicode.com/posts/">-->
<!--          <Button icon="ios-cloud-upload-outline">上传附件</Button>-->
<!--          <div slot="tip" style="color: #999">支持图片、文档等格式</div>-->
<!--        </Upload>-->
<!--      </FormItem>-->
    </Form>

    <div class="footer">
      <Button type="primary" @click="handleSave">保存</Button>
      <Button @click="handleCancel" style="margin-left: 10px">取消</Button>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/apis/restUtils";
export default {
  name: 'EditMaintenanceRecord',
  props: {
    record: Object,
    device: Object
  },
  data() {
    return {
      myMaintenanceStatus: '0',
    }
  },
  computed: {
    startTimeValue: {
      get() {
        return this.record.startTime ? new Date(this.record.startTime) : null;
      },
      set(val) {
        this.record.startTime = val ? formatDate(new Date(val), 'yyyy-MM-dd hh:mm') : ''; //.toISOString().slice(0, 16)
      }
    },
    endTimeValue: {
      get() {
        return this.record.endTime ? new Date(this.record.endTime) : null;
      },
      set(val) {
        this.record.endTime = val ? formatDate(new Date(val), 'yyyy-MM-dd hh:mm') : ''; //.toISOString().slice(0, 16)
        console.log('this.record.endTime', this.record.endTime);
      }
    }
  },
  mounted: function() {
    console.log("this.device :", this.device);
    console.log("this.record :", this.record);
    this.myMaintenanceStatus = this.record.maintenanceStatus === '1'? '维修完毕':'维修中';  //
    this.record.machinetoolId = this.device.id;
    //------------------
    if (!this.record.maintenanceStatus) {
      this.record.maintenanceStatus = '0'; // 默认维修中
    }
  },
  methods: {
    handleSave() {
      if (this.record.maintenanceStatus === '1' && !this.record.endTime) {
        this.$Message.warning('维修完毕状态必须填写结束时间');
        return;
      }
      this.$emit('save', this.record);
    },

    handleCancel() {
      this.$emit('cancel');
    },

    handleChange(value){
      console.log("value: ", value);
    }
  },
  watch: {
    myMaintenanceStatus : function(newVal) {
      console.log('watch record: ', newVal);
      this.record.maintenanceStatus = (newVal === '维修完毕'?'1':'0');
      // if (this.record.maintenanceStatus === '1' && !this.record.endTime) {
      //   console.log('this.record.maintenanceStatus: ', this.record.maintenanceStatus);
      //   this.record.endTime = new Date(); //.toISOString().slice(0, 16);
      // }
    }
  }
};
</script>

<style scoped>
.edit-maintenance {
  padding: 10px;
}

.footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}
</style>